import React from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';

import clubDict from '../../scripts/clubs';

import './styles.less';

const Insider = (props) => {
    const teamName = (teamId) => {
        if (teamId) {
            // eslint-disable-next-line
            return clubDict.find((elem) => elem.id == teamId).teamName;
        }
        return 'MLB';
    };

    const teamId = () => {
        const root = document.getElementById('_pagebuilder_index');
        if (root === null) return null;
        const teamIdRegex = /team-([0-9]*)/.exec(root.className);
        if (teamIdRegex !== null) {
            return teamIdRegex[1];
        }
        return null;
    };

    if (props.items.length < 3) {
        return <div className="p-insider" data-content-id={props.contentId} />;
    }

    const insiderPrimary = props.items[0];

    const insiderSecondary = [props.items[1], props.items[2]];

    const insiderTertiary = props.items.slice(3);

    return (
        <div className="p-insider" data-content-id={props.contentId}>
            <div className="l-grid__content-title u-text-h5">
                {props.teamId ? teamName(props.teamId) : teamName(teamId())} {props.i18n.club_insider}
            </div>
            <div className="l-grid p-insider__grid">
                <div className="l-grid__col l-grid__col--sm-8 l-grid__col--md-8 l-grid__col--lg-8 l-grid__col--xl-8">
                    <div className="l-grid__content">
                        <a href={insiderPrimary.url}>
                            <div className="p-insider__item">
                                <Image
                                    {...insiderPrimary.image}
                                    className="p-insider__image"
                                    altText={insiderPrimary.title}
                                />
                            </div>
                        </a>
                    </div>
                </div>

                <div className="l-grid__col l-grid__col--sm-4 l-grid__col--md-4 l-grid__col--lg-4 l-grid__col--xl-4">
                    <div className="l-grid p-insider__grid">
                        {insiderSecondary.map((item, i) => {
                            const key = i;
                            return (
                                <div className="l-grid__col l-grid__col--xs-6 l-grid__col--xs-6" key={key}>
                                    <div className="l-grid__content">
                                        <a href={item.url}>
                                            <div className="p-insider__item">
                                                <Image
                                                    {...item.image}
                                                    className="p-insider__image p-insider__image--aspect-nudge"
                                                    altText={item.title}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {insiderTertiary.map((item, i) => {
                    const key = i;
                    return (
                        <div
                            className="l-grid__col l-grid__col--sm-6 l-grid__col--md-6 l-grid__col--lg-6 l-grid__col--xl-6 p-insider__small-item"
                            key={key}
                        >
                            <div className="l-grid__content">
                                <a href={item.url}>
                                    <div className="p-insider__item--sm">
                                        <div className="p-insider__image">
                                            <Image {...item.image} />
                                        </div>
                                        <div className="u-text-h5">{item.title}</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

Insider.propTypes = {
    contentId: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            image: PropTypes.shape(Image.propTypes).isRequired
        })
    ).isRequired,
    teamId: PropTypes.string,
    i18n: PropTypes.shape({ club_insider: PropTypes.string })
};

Insider.defaultProps = {
    contentId: undefined,
    teamId: undefined,
    i18n: { club_insider: 'Insider' }
};

export default Insider;
